import { convert } from "@stepfinance/common";
import type { StepLiquidityPool } from "@stepfinance/liquidity";
import type { NormalizedTokenAccount } from "@stepfinance/tokens";
import BN from "bn.js";

import { cache } from "../../utils/cache";

export const useLPRatio = (pool: StepLiquidityPool | undefined, accounts: NormalizedTokenAccount[]) => {
  if (!pool) {
    return 0;
  }

  const poolMint = cache.getMint(pool.mintAddress);
  if (!poolMint) {
    return 0;
  }

  // FIXME: this should be stored as a number not a BN.
  // should use account.tokenAmount.uiAmount which is the uiAmount number and no need for conversion
  const totalAccountAmount = accounts.reduce(
    (total, account) => total.add(new BN(account.tokenAmount.amount)),
    new BN(0),
  );
  if (!pool.supply) {
    return 0;
  }
  return convert(totalAccountAmount, poolMint.decimals) / pool.supply;
};
